import { defineMessages } from "react-intl";

export const labelPrintDialogMessages = defineMessages({
  menuItemLabel: {
    id: "ZUGn5f",
    defaultMessage: "Print label",
    description: "product/variant page overflow menu item",
  },
  fieldsSectionLabel: {
    id: "CTjU3P",
    defaultMessage: "Fields to include",
    description: "print label dialog, section label",
  },
  fieldName: {
    id: "mJAsaa",
    defaultMessage: "Product name",
    description: "print label dialog, field checkbox",
  },
  fieldSku: {
    id: "sZYBZW",
    defaultMessage: "SKU (text)",
    description: "print label dialog, field checkbox",
  },
  fieldPrice: {
    id: "dQSC3m",
    defaultMessage: "Price",
    description: "print label dialog, field checkbox",
  },
  fieldBatch: {
    id: "HA2DXm",
    defaultMessage: "Batch tracking",
    description: "print label dialog, field checkbox",
  },
  fieldImage: {
    id: "32xDge",
    defaultMessage: "Image",
    description: "print label dialog, field checkbox",
  },
  fieldBarcode: {
    id: "SfjXq1",
    defaultMessage: "Barcode",
    description: "print label dialog, field checkbox",
  },
  fieldQrCode: {
    id: "BRj+Zy",
    defaultMessage: "QR code",
    description: "print label dialog, field checkbox",
  },
  fieldText: {
    id: "iejwrl",
    defaultMessage: "Text box",
    description: "print label dialog, field checkbox label used in the style panel heading",
  },
  fieldImporter: {
    id: "HwWNbA",
    defaultMessage: "Importer information",
    description: "print label dialog, field checkbox label used in the style panel heading",
  },
  importerFieldName: {
    id: "kkVHzp",
    defaultMessage: "Name",
    description: "label layout editor, checkbox for the importer element",
  },
  importerFieldAddress: {
    id: "2dSkp2",
    defaultMessage: "Address",
    description: "label layout editor, checkbox for the importer element",
  },
  importerFieldEmail: {
    id: "6m31rX",
    defaultMessage: "Email",
    description: "label layout editor, checkbox for the importer element",
  },
  importerFieldPhone: {
    id: "eOmI1H",
    defaultMessage: "Phone",
    description: "label layout editor, checkbox for the importer element",
  },
  fieldBarcodeText: {
    id: "7Ajmx7",
    defaultMessage: "Show text under barcode",
    description: "print label dialog, field checkbox, indented under the barcode checkbox",
  },
  barcodeHint: {
    id: "43r9XP",
    defaultMessage:
      "The barcode always encodes the SKU (Code128) — “SKU (text)” prints it as plain text elsewhere on the label; “Show text under barcode” prints it under the bars themselves.",
    description: "print label dialog, hint text",
  },
  snapshotControlsLabel: {
    id: "7+uZ4v",
    defaultMessage: "Fit and adjust design",
    description: "print label dialog, controls for fitting a template snapshot to the chosen stock",
  },
  cropToFill: {
    id: "+fO2qr",
    defaultMessage: "Crop to fill",
    description: "print label dialog button that fills the stock and crops overflow",
  },
  fitWholeDesign: {
    id: "Opd/pG",
    defaultMessage: "Fit whole design",
    description: "print label dialog button that fits the entire design on the stock",
  },
  rotateLeft: {
    id: "7kZ0fl",
    defaultMessage: "Rotate left",
    description: "print label dialog button to rotate the design counter-clockwise",
  },
  rotateRight: {
    id: "bV00Os",
    defaultMessage: "Rotate right",
    description: "print label dialog button to rotate the design clockwise",
  },
  zoomLabel: {
    id: "OiOxxX",
    defaultMessage: "Zoom: {zoom}%",
    description: "print label dialog zoom slider accessible label",
  },
  rollLayoutLabel: {
    id: "mt0fAW",
    defaultMessage: "Roll layout",
    description: "print label dialog settings for labels placed across a roll",
  },
  rollRowsPerPageLabel: {
    id: "l9O+9s",
    defaultMessage: "Rows per page",
    description: "print label dialog, how many rows of roll labels the printer feeds per page",
  },
  rollColumnsLabel: {
    id: "KIRWhv",
    defaultMessage: "Labels per row",
    description: "print label dialog number of labels printed across roll width",
  },
  rollLeftMarginLabel: {
    id: "jKAr40",
    defaultMessage: "Left margin (mm)",
    description: "print label dialog left margin on the roll",
  },
  rollRightMarginLabel: {
    id: "B43Lqk",
    defaultMessage: "Right margin (mm)",
    description: "print label dialog right margin on the roll",
  },
  rollMiddleGapLabel: {
    id: "oqTYGf",
    defaultMessage: "Middle gap (mm)",
    description: "print label dialog gap between labels side by side on the roll",
  },
  rollRowGapLabel: {
    id: "jtfnaP",
    defaultMessage: "Row gap (mm)",
    description: "print label dialog gap between one row of roll labels and the next",
  },
  rollOutputWidth: {
    id: "khl2G+",
    defaultMessage:
      "Configured page size: {width} × {height} mm (the gap after each row is included in the height).",
    description: "print label dialog hint showing the roll width and per-row height",
  },
  rollPrintSettingsHint: {
    id: "fHHkC/",
    defaultMessage:
      "The browser cannot change your printer's paper size. In the print dialog select exactly this size (if it is missing, add it under Paper Size → Manage Custom Sizes in the system printer settings), with margins set to none and scale 100%.",
    description:
      "print label dialog note explaining that custom roll media may need setup in OS printer settings",
  },
  printPageSizeSummary: {
    id: "0U+JYk",
    defaultMessage: "Paper size to select in the print dialog: {size}",
    description:
      "print label page, shown beside the Print button — the exact page size sent to the printer",
  },
  printPageSizeCopy: {
    id: "7wTXD7",
    defaultMessage: "Copy size",
    description:
      "print label page, button copying the page size so it can be typed into system printer settings",
  },
  printPageSizeCopied: {
    id: "capeTO",
    defaultMessage: "Copied {size}",
    description: "print label page, notification after copying the page size",
  },
  paperSheet: {
    id: "KHi01C",
    defaultMessage: "{name} sheet, {width}×{height}mm labels (normal printer)",
    description: "print label dialog, paper preset name",
  },
  paperRoll: {
    id: "NKRI44",
    defaultMessage: "Label roll {width}×{height}mm (thermal printer)",
    description: "print label dialog, paper preset name",
  },
  paperCustom: {
    id: "MdA5as",
    defaultMessage: "Custom size…",
    description: "print label dialog, paper preset name",
  },
  customKindLabel: {
    id: "UBPg2h",
    defaultMessage: "Printer type",
    description: "print label dialog, custom size section",
  },
  customKindSheet: {
    id: "fjlygD",
    defaultMessage: "Sheet (normal printer)",
    description: "print label dialog, custom size toggle",
  },
  customKindRoll: {
    id: "Y34yY0",
    defaultMessage: "Roll (thermal printer)",
    description: "print label dialog, custom size toggle",
  },
  customPageLabel: {
    id: "5VSNYY",
    defaultMessage: "Sheet size",
    description: "print label dialog, custom size section",
  },
  customWidthLabel: {
    id: "oxq264",
    defaultMessage: "Label width (mm)",
    description: "print label dialog, custom size input",
  },
  customHeightLabel: {
    id: "h/6hMW",
    defaultMessage: "Label height (mm)",
    description: "print label dialog, custom size input",
  },
  resizeContentModeLabel: {
    id: "o1plNE",
    defaultMessage: "When resizing",
    description:
      "label layout editor, selector next to the width/height inputs controlling how content reacts to a label size change",
  },
  resizeContentModeScale: {
    id: "/q/dao",
    defaultMessage: "Scale content to fit",
    description:
      "label layout editor, resize-mode option — text/marks grow or shrink along with the label",
  },
  resizeContentModeKeep: {
    id: "A8rGZy",
    defaultMessage: "Keep content the same size",
    description:
      "label layout editor, resize-mode option — text/marks stay their current size; only the label canvas changes",
  },
  resizeContentModeHint: {
    id: "rX1ieV",
    defaultMessage:
      "Change label width or height to compare. Scale resizes text, images and icons; Keep preserves their current size.",
    description: "label layout editor, hint explaining the resize mode options",
  },
  perPageFractionLabel: {
    id: "tqJdKT",
    defaultMessage: "Quick sizes",
    description: "print label dialog, custom size section, fraction-of-page presets heading",
  },
  perPageFraction: {
    id: "Xlm7qD",
    defaultMessage: "{count, plural, one {Full page} other {# per page}}",
    description: "print label dialog, custom size section, fraction-of-page preset button",
  },
  perPageCaption: {
    id: "aXnRWL",
    defaultMessage:
      "{perPage} per sheet ({columns} × {rows}) — {pages, plural, one {# page} other {# pages}} needed",
    description: "print label dialog, sheet capacity caption",
  },
  printNote: {
    id: "QGaVdz",
    defaultMessage:
      "Print opens your browser’s own print dialog — pick your normal printer or your label printer there; the page size above is sent along automatically.",
    description: "print label dialog, hint text",
  },
  previewTitle: {
    id: "MtyfX6",
    defaultMessage: "{count, plural, one {Preview — # label} other {Preview — # labels}}",
    description: "print label dialog, preview panel heading",
  },
  cancel: {
    id: "U7E40k",
    defaultMessage: "Cancel",
    description: "print label dialog, button",
  },
  back: {
    id: "CzhL2U",
    defaultMessage: "Back",
    description: "print label dialog, button returning from page-mode configuration to the queue",
  },
  print: {
    id: "5vPBBT",
    defaultMessage: "Print",
    description: "print label dialog, button",
  },
  previewPreviousPage: {
    id: "im10y6",
    defaultMessage: "Previous page",
    description: "label printing page, preview pager button",
  },
  previewNextPage: {
    id: "0d0ytx",
    defaultMessage: "Next page",
    description: "label printing page, preview pager button",
  },
  templateSetupSave: {
    id: "XpgLhx",
    defaultMessage: "Use as this template's default",
    description: "label printing page, saves the current paper setup with the selected template",
  },
  templateSetupSaved: {
    id: "5E1b8j",
    defaultMessage: "Paper setup saved as the default for “{name}”",
    description: "label printing page, notification after saving a template's paper setup",
  },
  templateSetupReset: {
    id: "pqgLq2",
    defaultMessage: "Back to the template's setup",
    description: "label printing page, discards the person's own paper setup for this template",
  },
  ownSetupNote: {
    id: "meD9A6",
    defaultMessage: "Your own setup for this template (saved in this browser)",
    description: "label printing page, shown when the person changed the template's paper setup",
  },
  printCount: {
    id: "mVF5+4",
    defaultMessage: "{count, plural, =0 {Print} other {Print #}}",
    description: "label printing page, sticky print button with the number of labels",
  },
  labelsCount: {
    id: "KD2AYd",
    defaultMessage: "{count, plural, one {# label} other {# labels}}",
    description: "label printing page, header summary pill",
  },
  emptyPreview: {
    id: "ITtvlB",
    defaultMessage: "The labels appear here once something is in the queue.",
    description: "label printing page, preview card while the queue is empty",
  },
  paperAdjust: {
    id: "wlXTfT",
    defaultMessage: "Adjust",
    description: "label printing page, toggles rotation/zoom/roll/custom size settings",
  },
  paperLabel: {
    id: "2pVCdd",
    defaultMessage: "Paper",
    description: "label printing page, paper size select label",
  },
});

export const labelCanvasEditorMessages = defineMessages({
  editorHint: {
    id: "mPQgem",
    defaultMessage:
      "Drag a field to move it, drag its corner handle to resize it, or Shift-drag to select several fields.",
    description: "label layout editor, hint text",
  },
  addTextBox: {
    id: "dnCNZV",
    defaultMessage: "Add text box",
    description: "label layout editor, button — adds a new custom text box each click",
  },
  addImage: {
    id: "XVqG/A",
    defaultMessage: "Add image",
    description: "label layout editor, button adding another product image to the label",
  },
  imageGalleryHint: {
    id: "9vELTF",
    defaultMessage:
      "Choose a product image for this label element. The first image is selected by default.",
    description: "label layout editor, hint above image gallery",
  },
  imageNumber: {
    id: "rSjCNo",
    defaultMessage: "Image {number}",
    description: "label layout editor, accessible label for a product image in the gallery",
  },
  noProductImages: {
    id: "eu3wGm",
    defaultMessage: "No product images are available for this item.",
    description: "label layout editor, empty image gallery state",
  },
  removeElement: {
    id: "nUbLXd",
    defaultMessage: "Remove",
    description: "label layout editor, button — removes the selected field/text box",
  },
  textBoxContentLabel: {
    id: "+Vl8nZ",
    defaultMessage: "Text",
    description: "label layout editor, input label for a custom text box's content",
  },
  showFieldLabel: {
    id: "1KS1pn",
    defaultMessage: "Show “{label}:” label",
    description: "label layout editor, checkbox — prefix the field's value with its name",
  },
  fontSizeLabel: {
    id: "hI2JBP",
    defaultMessage: "Size (pt)",
    description: "label layout editor, style panel, font size input",
  },
  boldLabel: {
    id: "oOLqUy",
    defaultMessage: "Bold",
    description: "label layout editor, style panel, checkbox",
  },
  alignLeft: {
    id: "TqkGSM",
    defaultMessage: "Left",
    description: "label layout editor, style panel, text alignment button",
  },
  alignCenter: {
    id: "rXDtYn",
    defaultMessage: "Center",
    description: "label layout editor, style panel, text alignment button",
  },
  alignRight: {
    id: "XhnnW3",
    defaultMessage: "Right",
    description: "label layout editor, style panel, text alignment button",
  },
  colorLabel: {
    id: "sagGu2",
    defaultMessage: "Color",
    description: "label layout editor, style panel, color picker label",
  },
  contentOverrideLabel: {
    id: "RG3IRi",
    defaultMessage:
      "Custom text — used only when printing a single variant, not saved with the template",
    description: "label layout editor, style panel, content-override textarea label",
  },
  resetToProductData: {
    id: "PybWYB",
    defaultMessage: "Reset to product data",
    description: "label layout editor, style panel, button clearing a content override",
  },
  addMarkLabel: {
    id: "iv7jrB",
    defaultMessage: "Add mark",
    description: "label layout editor, dropdown label — adds a compliance mark graphic",
  },
  markSelectLabel: {
    id: "JcXb4Y",
    defaultMessage: "Mark",
    description: "label layout editor, style panel, select — which compliance mark to show",
  },
  markCe: {
    id: "xwpJai",
    defaultMessage: "CE",
    description: "label layout editor, compliance mark name",
  },
  markCeRed: {
    id: "MikmzV",
    defaultMessage: "CE (red)",
    description: "label layout editor, compliance mark name — same CE mark, red by default",
  },
  markUkca: {
    id: "DexEWF",
    defaultMessage: "UKCA",
    description: "label layout editor, compliance mark name",
  },
  markWeee: {
    id: "oGPBaT",
    defaultMessage: "WEEE (crossed-out bin)",
    description: "label layout editor, compliance mark name",
  },
  markRohs: {
    id: "kqEQ6Z",
    defaultMessage: "RoHS",
    description: "label layout editor, compliance mark name",
  },
  markRecycle: {
    id: "KFkLvu",
    defaultMessage: "Recycle",
    description: "label layout editor, compliance mark name",
  },
  markReach: {
    id: "TUKqOd",
    defaultMessage: "REACH compliance",
    description: "label layout editor, compliance mark name",
  },
  markGhs01: {
    id: "v+0obT",
    defaultMessage: "GHS01 Explosive",
    description: "label layout editor, GHS hazard pictogram name",
  },
  markGhs02: {
    id: "Wsqysa",
    defaultMessage: "GHS02 Flammable",
    description: "label layout editor, GHS hazard pictogram name",
  },
  markGhs03: {
    id: "U17idz",
    defaultMessage: "GHS03 Oxidising",
    description: "label layout editor, GHS hazard pictogram name",
  },
  markGhs04: {
    id: "k5n0iW",
    defaultMessage: "GHS04 Gas under pressure",
    description: "label layout editor, GHS hazard pictogram name",
  },
  markGhs05: {
    id: "eJdNi6",
    defaultMessage: "GHS05 Corrosive",
    description: "label layout editor, GHS hazard pictogram name",
  },
  markGhs06: {
    id: "yNt1SI",
    defaultMessage: "GHS06 Acute toxicity",
    description: "label layout editor, GHS hazard pictogram name",
  },
  markGhs07: {
    id: "MoTG/a",
    defaultMessage: "GHS07 Harmful / irritant",
    description: "label layout editor, GHS hazard pictogram name",
  },
  markGhs08: {
    id: "vRvON9",
    defaultMessage: "GHS08 Health hazard",
    description: "label layout editor, GHS hazard pictogram name",
  },
  markGhs09: {
    id: "B3n4Z8",
    defaultMessage: "GHS09 Environmental hazard",
    description: "label layout editor, GHS hazard pictogram name",
  },
  markBrand: {
    id: "e/yYUO",
    defaultMessage: "MAXCEI logo",
    description: "label layout editor, compliance mark name (brand wordmark)",
  },
  markBrandStacked: {
    id: "s3WPLU",
    defaultMessage: "MAXCEI logo (stacked)",
    description: "label layout editor, stacked MAXCEI brand mark option",
  },
  undo: {
    id: "ITXyFO",
    defaultMessage: "Undo",
    description: "label layout editor, button",
  },
  redo: {
    id: "s7VetP",
    defaultMessage: "Redo",
    description: "label layout editor, button",
  },
  sectionFieldsTitle: {
    id: "NtY4OO",
    defaultMessage: "Fields",
    description: "label layout editor, sidebar section header — toggles which fields show",
  },
  sectionAddElementTitle: {
    id: "LQuqmE",
    defaultMessage: "Add element",
    description: "label layout editor, sidebar section header — add text box / compliance mark",
  },
  sectionSelectedTitle: {
    id: "k+1/bF",
    defaultMessage: "Selected element",
    description:
      "label layout editor, sidebar section header — the currently selected element's settings",
  },
  selectedElementsCount: {
    id: "+I4Atk",
    defaultMessage: "{count} elements selected",
    description: "label layout editor, selected elements section header",
  },
  groupSelectionHint: {
    id: "p2aDdK",
    defaultMessage: "Drag any selected field to move the group together.",
    description: "label layout editor, hint shown when multiple fields are selected",
  },
  alignSectionLabel: {
    id: "08jx2N",
    defaultMessage: "Align",
    description: "label layout editor, multi-selection panel — heading above the align buttons",
  },
  alignBoxLeft: {
    id: "mCWpmT",
    defaultMessage: "Left",
    description: "label layout editor, multi-selection panel — aligns selected boxes' left edges",
  },
  alignBoxCenterX: {
    id: "gUS+2H",
    defaultMessage: "Center",
    description: "label layout editor, multi-selection panel — centers selected boxes horizontally",
  },
  alignBoxRight: {
    id: "2m+D7l",
    defaultMessage: "Right",
    description: "label layout editor, multi-selection panel — aligns selected boxes' right edges",
  },
  alignBoxTop: {
    id: "2xWKYT",
    defaultMessage: "Top",
    description: "label layout editor, multi-selection panel — aligns selected boxes' top edges",
  },
  alignBoxCenterY: {
    id: "n3OmX/",
    defaultMessage: "Middle",
    description: "label layout editor, multi-selection panel — centers selected boxes vertically",
  },
  alignBoxBottom: {
    id: "7rzYH1",
    defaultMessage: "Bottom",
    description: "label layout editor, multi-selection panel — aligns selected boxes' bottom edges",
  },
  canvasTitle: {
    id: "i/qHTj",
    defaultMessage: "Layout",
    description: "label layout editor, canvas column header",
  },
  fullscreenEditor: {
    id: "RZGeYa",
    defaultMessage: "Open full screen editor",
    description: "label layout editor, button title",
  },
  exitFullscreenEditor: {
    id: "d8FwEs",
    defaultMessage: "Exit full screen editor",
    description: "label layout editor, button title",
  },
});

export const labelFieldLabelMessages = defineMessages({
  skuPrefix: {
    id: "EE6nej",
    defaultMessage: "SKU: ",
    description: "printed label, prefix shown before the SKU value when its label is enabled",
  },
  pricePrefix: {
    id: "7Tur7X",
    defaultMessage: "Price: ",
    description: "printed label, prefix shown before the price value when its label is enabled",
  },
  batchPrefix: {
    id: "UnoOIJ",
    defaultMessage: "Batch: ",
    description: "printed label, prefix shown before the batch code when its label is enabled",
  },
  importerPrefix: {
    id: "o5hn/e",
    defaultMessage: "Importador:",
    description: "printed label, heading line shown above the importer's company name",
  },
  noBatchNumber: {
    id: "eOfgbt",
    defaultMessage: "No batch assigned",
    description:
      "printed label, placeholder shown in the editor when a variant has no batch code yet",
  },
});

export const labelTemplateMessages = defineMessages({
  templateLabel: {
    id: "oC8ag5",
    defaultMessage: "Template",
    description: "print label dialog, template select label",
  },
  templateAuto: {
    id: "131VS/",
    defaultMessage: "Auto (each product's own)",
    description: "print label dialog, template select option",
  },
  templateCustomUnsaved: {
    id: "hha1ub",
    defaultMessage: "Custom (unsaved)",
    description: "print label dialog, template select option after editing a brand-new template",
  },
  templateCopyName: {
    id: "T/bIpV",
    defaultMessage: "{name} (copy)",
    description:
      "print label dialog, default name suggested when saving a duplicate of a template — {name} is the original's name",
  },
  templateEditedUnsaved: {
    id: "FQh+NO",
    defaultMessage: "{name} (edited)",
    description:
      "print label dialog, template select option after editing an EXISTING template — {name} is the template's own name",
  },
  editLayout: {
    id: "/VhGIU",
    defaultMessage: "Edit layout",
    description: "print label dialog, button",
  },
  cancelEditing: {
    id: "AinIGo",
    defaultMessage: "Discard changes",
    description: "print label dialog, button, discard in-progress layout edits",
  },
  saveAsNewTemplate: {
    id: "V+CI/O",
    defaultMessage: "Save as new template",
    description: "print label dialog, button",
  },
  updateTemplate: {
    id: "eqf3OJ",
    defaultMessage: "Update “{name}”",
    description: "print label dialog, button, updates the template being edited",
  },
  templateNameLabel: {
    id: "ZaxOUc",
    defaultMessage: "Template name",
    description: "print label dialog, save-layout form input",
  },
  assignToSelected: {
    id: "y1t0K8",
    defaultMessage:
      "{count, plural, one {Also set as this product's default} other {Also set as default for all # selected products}}",
    description: "print label dialog, save-layout form checkbox",
  },
  saveConfirm: {
    id: "EOScYU",
    defaultMessage: "Save",
    description: "print label dialog, save-layout form confirm button",
  },
  templateSaved: {
    id: "tHN6sv",
    defaultMessage: "Label template saved",
    description: "print label dialog, notification",
  },
  templateSaveFailed: {
    id: "1zrGBj",
    defaultMessage: "Could not save the label template",
    description: "print label dialog, notification",
  },
  galleryEmpty: {
    id: "4KsVJ/",
    defaultMessage: "No saved templates yet — edit the layout and save one to build your gallery.",
    description: "print label dialog, template gallery, empty state",
  },
  galleryEdit: {
    id: "wJbxvA",
    defaultMessage: "Edit",
    description: "print label dialog, template gallery card, button, paired side-by-side with Use",
  },
  galleryCreatedBy: {
    id: "67yGzH",
    defaultMessage: "Saved by {name}",
    description: "print label template gallery, identifies the owner of a personal template copy",
  },
  galleryDelete: {
    id: "yJBfhh",
    defaultMessage: "Delete",
    description: "print label dialog, template gallery card button deleting a template",
  },
  deleteTemplateTitle: {
    id: "V5jcxD",
    defaultMessage: "Delete template",
    description: "print label dialog, confirm-delete dialog title",
  },
  deleteTemplateBody: {
    id: "uL5yWV",
    defaultMessage:
      "Delete “{name}”? Products assigned to it fall back to the default template. This cannot be undone.",
    description: "print label dialog, confirm-delete dialog body",
  },
  deleteDefaultTemplateBody: {
    defaultMessage:
      "“{name}” is the default template. Products with no template of their own will print with the built-in layout until you set another default. Delete it? This cannot be undone.",
    id: "kM4rhN",
    description:
      "print label dialog, confirm-delete dialog body when deleting the default template",
  },
  templateDeleted: {
    id: "igZrGy",
    defaultMessage: "Template deleted",
    description: "print label dialog, notification after deleting a template",
  },
  templateDeleteFailed: {
    id: "Ko3TdK",
    defaultMessage: "Could not delete the template",
    description: "print label dialog, notification when deleting a template fails",
  },
  galleryRename: {
    defaultMessage: "Rename",
    id: "dNWgAu",
    description: "print label dialog, template gallery card button renaming a template",
  },
  renameTemplateTitle: {
    defaultMessage: "Rename template",
    id: "PyXGiq",
    description: "print label dialog, rename-template dialog title",
  },
  templateRenamed: {
    defaultMessage: "Template renamed",
    id: "OPcq/5",
    description: "print label dialog, notification after renaming a template",
  },
  templateNameRequired: {
    defaultMessage: "Give the template a name",
    id: "SVh4v2",
    description: "print label dialog, helper text under an empty template name field",
  },
  templateNameTaken: {
    defaultMessage: "A template named “{name}” already exists",
    id: "6cdbFB",
    description: "print label dialog, helper text when the template name is already used",
  },
  saveAsNewNeedsNewName: {
    defaultMessage: "To save as a new template, enter a different name",
    id: "sDZlY/",
    description:
      "print label dialog, save form helper text while the name still matches the template being edited",
  },
  galleryDuplicate: {
    id: "7VZaMZ",
    defaultMessage: "Duplicate",
    description:
      "print label dialog, template gallery card button shown below the editor while creating a new template — loads that template's layout as a starting point",
  },
  duplicateFromTitle: {
    id: "XHiEcU",
    defaultMessage: "Or start from a saved template",
    description:
      "print label dialog, heading above the gallery shown below the editor for a new template",
  },
  galleryDefaultBadge: {
    id: "+xzMbk",
    defaultMessage: "Default",
    description: "print label dialog, template gallery card, badge on the default template",
  },
  setAsDefaultLabel: {
    id: "eX1hrI",
    defaultMessage: "Use for all products with no template of their own",
    description: "print label dialog, save-layout form checkbox",
  },
  defaultTemplateUpdated: {
    id: "7yIFDG",
    defaultMessage: "Default layout updated",
    description: "print label dialog, notification after saving the default template",
  },
  newTemplate: {
    id: "d3hgLB",
    defaultMessage: "New template",
    description: "label printing page, button starting a blank template; editor title for it",
  },
  autoTemplateName: {
    id: "hUoLWY",
    defaultMessage: "Automatic",
    description:
      "label printing page, template tile that prints each product with its own template",
  },
  autoTemplateHint: {
    id: "/J86Jv",
    defaultMessage: "Each product's own template",
    description: "label printing page, subtitle of the automatic template tile",
  },
  editTemplateNamed: {
    id: "e/wnfH",
    defaultMessage: "Edit {name}",
    description: "label printing page, edit icon button label; editor title",
  },
  moreActions: {
    id: "RI/4U8",
    defaultMessage: "More actions",
    description: "label printing page, template tile overflow menu button",
  },
  editCopyHint: {
    id: "a4Y8rR",
    defaultMessage: "Edit a copy (the shared template stays as it is)",
    description: "label printing page, edit button tooltip on a template the user can't change",
  },
  editingCopyNote: {
    id: "MlHpEj",
    defaultMessage: "Saved as your own template; “{name}” stays unchanged",
    description: "label editor top bar, shown while editing a copy of a template",
  },
  makeDefault: {
    id: "8d0fKH",
    defaultMessage: "Make default",
    description: "label printing page, template tile menu item",
  },
  useWithoutSaving: {
    id: "0GjkyA",
    defaultMessage: "Use without saving",
    description: "label editor top bar, leave the editor keeping the unsaved layout for this print",
  },
  unsavedChanges: {
    id: "SfVK4O",
    defaultMessage: "Unsaved changes",
    description: "label editor top bar, shown once the layout differs from where editing started",
  },
});
